var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73091 3.01553C6.51577 2.47768 5.99485 2.125 5.41557 2.125H3.46711C2.72588 2.125 2.125 2.72574 2.125 3.46696C2.125 9.76737 7.23263 14.875 13.533 14.875C14.2743 14.875 14.875 14.2741 14.875 13.5328L14.8753 11.5841C14.8753 11.0048 14.5227 10.4839 13.9849 10.2688L12.1174 9.52208C11.6343 9.32883 11.0842 9.4158 10.6845 9.74892L10.2025 10.1509C9.63961 10.62 8.81141 10.5827 8.29331 10.0646L6.93616 8.70617C6.41806 8.18807 6.37977 7.36053 6.84884 6.79765L7.25073 6.31571C7.58385 5.91597 7.6716 5.36574 7.47834 4.88261L6.73091 3.01553Z",
    stroke: "#003057",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.37cf58dcfbbdcb2f2541fd456b0ee15f.svg";
export { ForwardRef as ReactComponent };